import { useEffect, useRef, useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

export default function PdfPreview({ url = "" }) {
  const [numPages, setNumPages] = useState();
  const [pageWidth, setPageWidth] = useState();
  const [loadError, setLoadError] = useState(null);
  const previewRef = useRef(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setLoadError(null);
  }

  function onDocumentLoadError(error) {
    setLoadError(error);
  }

  useEffect(() => {
    const previewElement = previewRef.current;
    if (!previewElement) {
      return undefined;
    }

    const updatePageWidth = () => {
      setPageWidth(previewElement.clientWidth);
    };

    updatePageWidth();
    const resizeObserver = new ResizeObserver(updatePageWidth);
    resizeObserver.observe(previewElement);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div ref={previewRef} style={{ width: "100%" }}>
      {loadError && <p role="alert">Unable to load PDF preview.</p>}
      <Document
        onError={onDocumentLoadError}
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        options={options}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} width={pageWidth} />
        ))}
      </Document>
    </div>
  );
}